import React, { ReactElement } from 'react';
import TopNavigation, {
  TopNavigationProps,
} from '@amzn/awsui-components-console/top-navigation';

const utilities = [
  {
    href: 'https://issues.amazon.com/issues/create?template=1dde11d1-5886-45bb-abc2-56ca47b272fb',
    external: true,
    type: 'button',
    text: 'Feature Request',
  },
  {
    href: 'https://issues.amazon.com/issues/create?template=4a21b015-f5a8-4f46-bf94-c3a2db376c5c',
    external: true,
    type: 'button',
    text: 'Report an Issue',
  },
] as TopNavigationProps.Utility[];

export const AppFooter = (): ReactElement => (
  <footer className="app-footer">
    <TopNavigation
      data-testid="app-footer"
      identity={{ href: '#' }}
      utilities={utilities}
    />
  </footer>
);
